import { render } from "./ProyectoN2ServiciosColectivos.vue?vue&type=template&id=3d0e8555&ts=true"
import script from "./ProyectoN2ServiciosColectivos.vue?vue&type=script&lang=ts"
export * from "./ProyectoN2ServiciosColectivos.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__